let conExt = {};
const blockedDomains = [
  'docomo.ne.jp', 'ezweb.ne.jp', 'au.com', 'softbank.ne.jp',
  'i.softbank.jp', 'ymobile.ne.jp', 'rakuten.jp', 'uqmobile.jp'
];

window.addEventListener("DOMContentLoaded", contactExtLaunch);

function contactExtLaunch() {
  conExt.ui = {};
  conExt.ui.nForm = document.getElementById("contact_form");
  conExt.ui.nEmail = conExt.ui.nForm.querySelector("#contact-form-email");

  let isClearing = false;

  function checkCarrierEmail() {
    if (isClearing) return;
    const value = conExt.ui.nEmail.value;
    const atIndex = value.indexOf('@');
    if (atIndex === -1) return;

    const domain = value.slice(atIndex + 1).toLowerCase();
    if (blockedDomains.includes(domain)) {
      isClearing = true;
      window.alert('携帯キャリア発行によるメールアドレスは無効です');
      conExt.ui.nEmail.value = '';
      isClearing = false;
    }
  }

  conExt.ui.nEmail.addEventListener('input', checkCarrierEmail);
  conExt.ui.nEmail.addEventListener('blur', checkCarrierEmail);
  conExt.ui.nForm.addEventListener('submit', function (e) {
    const value = conExt.ui.nEmail.value;
    const atIndex = value.indexOf('@');
    if (atIndex !== -1) {
      const domain = value.slice(atIndex + 1).toLowerCase();
      if (blockedDomains.includes(domain)) {
        e.preventDefault();
        window.alert('携帯キャリア発行によるメールアドレスは無効です');
        conExt.ui.nEmail.value = '';
        conExt.ui.nEmail.focus();
      }
    }
  });
  
}